import { render, staticRenderFns } from "./LiveAgentMessage.vue?vue&type=template&id=07f753f5&scoped=true"
import script from "./LiveAgentMessage.vue?vue&type=script&lang=ts"
export * from "./LiveAgentMessage.vue?vue&type=script&lang=ts"
import style0 from "./LiveAgentMessage.vue?vue&type=style&index=0&id=07f753f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f753f5",
  null
  
)

export default component.exports